import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fi from "./locales/fi.json";
import en from "./locales/en.json";

export const SUPPORTED_LANGUAGES = ["fi", "en"] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: Language = "fi";

// Finnish is primary (ADR-0001 / E1). The selection is persisted in
// localStorage so it survives the OIDC round-trip and reloads
// (E1 US-1.1: "Kielivalinta (FI/EN) toimii ja säilyy kirjautumisen yli").
export const LANGUAGE_STORAGE_KEY = "clms.lang";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fi: { translation: fi },
      en: { translation: en },
    },
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    nonExplicitSupportedLngs: true,
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

// Keep <html lang> in sync for a11y (WCAG 3.1.1/3.1.2) and screen readers.
function syncHtmlLang(lng: string) {
  const base = lng.split("-")[0];
  document.documentElement.lang = (SUPPORTED_LANGUAGES as readonly string[]).includes(base)
    ? base
    : DEFAULT_LANGUAGE;
}
syncHtmlLang(i18n.language);
i18n.on("languageChanged", syncHtmlLang);

export default i18n;
